import React from 'react';
import log from 'loglevel';
import { callLink } from "components/Links.mjs";
import { Link } from 'gatsby';
import { dayAndTime } from "components/Dates.mjs";
import { isAfter } from 'date-fns';
import { FaCalendarCheck, FaClock } from 'react-icons/fa';

const CallsCard = (props) => {
  log.debug("CallsCard:", props);
  const { isApproved, exchange, symbol, event: { quarter, year, conference_date, audio_file } } = props;
  const conferenceDate = new Date(conference_date);
  const { date, day, time } = dayAndTime(conferenceDate);
  const today = new Date();
  const conferenceInFuture = isAfter(conferenceDate, today);

  const callPath = callLink(exchange, symbol, year, quarter);
  return (
    <div className='calls-card'>
      <div className="call-card">
        <div className="qno">{quarter.toUpperCase()}</div>

        <p className="text">{date}</p>

        <div className="btn-container">
          <Link to={callPath} className="btn btn-primary">
            <>
              <span className="icon">
                { audio_file ?
                  <>
                    { isApproved ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14">
                          <path id="Polygon_1" data-name="Polygon 1"
                            d="M6.156,1.326a1,1,0,0,1,1.687,0l5.178,8.137A1,1,0,0,1,12.178,11H1.822A1,1,0,0,1,.978,9.463Z"
                            transform="translate(11) rotate(90)" fill="#fff" />
                        </svg>
                      :
                      <FaClock />
                    }
                  </>
                  :
                  <>
                    { conferenceInFuture ? <FaCalendarCheck /> : <FaClock /> }
                  </>
                }
              </span>
            </>
            { audio_file ?
              <>
                { isApproved ? "Listen" : "Awaiting Approval" }
              </>
              :
              <>
                { conferenceInFuture ? "Scheduled" : "Pending" }
              </>
            }
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CallsCard;